import axios from '@/plugins/http';
import VueClipBoard from 'vue-clipboard2';
import Mixin from '@/plugins/mixins.js';
import VueLazyload from 'vue-lazyload';

const register = (Vue) => {
  Vue.config.productionTip = false;
  Vue.prototype.$axios = axios;

  Vue.use({
    install() {
      Vue.component('Mixin', Mixin);
    }
  });

  // 图片懒加载
  Vue.use(VueLazyload, {
    observer: true,
    attempt: 1
  });

  //判断手机还是pc
  Vue.prototype.$getDev = () => {
    return window.screen.width <= 767 ? 'mobile' : 'pc';
  };
  Vue.prototype.$setPoint = function (activityCode, enumKey) {
    axios.post('api/v1/common/eventTracing', { activityCode, enumKey });
  };
  // 复制
  VueClipBoard.config.autoSetContainer = true // autoSetContainer需要设置为tru
  Vue.use(VueClipBoard);

  /**
   * 节流
   * 入参 func delay
   * throttleFlag  标记执行
   */
  Vue.prototype.$throttle = (func, delay) => {
    var prev = Date.now();
    return function () {
      let context = this;
      let args = arguments;
      let now = Date.now();
      if (now - prev >= delay) {
        func.apply(context, args);
        prev = Date.now();
      }
    };
  };

  /**
   * 防抖
   */
  Vue.prototype.$debounce = (func, delay) => {
    let timeout = null;
    return function () {
      if (timeout !== null) clearTimeout(timeout);
      timeout = setTimeout(func, delay);
    };
  };
};

export default register;
